<template>
    <CCard>
        <CCardBody>
            <CCard>
                <CCardHeader 
                    @click="desplegarOpciones" 
                    class="btn text-left"
                    > 
                    <strong>Configuración Módulos</strong>
                    
                </CCardHeader>
                <CCollapse :show="verOpcionesClientes">
                    <CCardBody class="m-1">
                        
                    <span  v-tippy="getBaseTippy('<div><h5>IMPORTANTE!</h5></div><div>Los campos como Nombre, Icono y Orden por ahora están asignados a todos los clientes, por lo que no se pueden modificar para cada uno</div><hr> El borde del submodulo(al igual que los modulos) indican si está habilitado/Deshabilitado para el cliente (Verde/Rojo). <hr> <div>Los iconos dentro (cruz o check) indican que los modulos/submodulos estan Asignados al cliente o no, al estar asignados este módulo lo vera elñ cliente pero no tendrá permisos para ingresar</div>')">
                        <CIcon name="cil-bell-exclamation" size="lg" class="mr-1" style="color:brown" />
                    </span>
                        <span v-if="!editarModulos">
                            <CButton color="warning" size="sm" class="mt-1 mb-1 mr-1"                       
                                @click="editarModulosCliente()"
                            >
                                <CIcon name="cil-pencil" style="height: 12px;" /> 
                                <span >Modificar modulos Cliente</span>
                            </CButton>
                        </span>
                        <span v-else>
                            <CButton 
                            :disabled="modificandoConfiguracion" 
                            color="danger" size="sm" class="mt-1 mb-1 mr-1"
                                @click="cancelarEdicion()"
                            >
                                <CIcon name="cil-x-circle" style="height: 12px;" />
                                <span>Cancelar Modificar modulos</span>
                            </CButton>
                        </span>

                        <span v-if="editarModulos">
                            <CButton
                                :disabled="modificandoConfiguracion" 
                                size="sm" class="mt-1 mb-1 btnPrincipalVapp"                       
                                @click="setModulosCliente"
                            >
                                <CIcon name="cil-check-circle" style="height: 12px;" :class="modificandoConfiguracion?'imgr':''" /> 
                                <span>Guardar Cambios</span>
                            </CButton>
                        </span>
                        <CRow>
                            <CCol sm='6' md='5' lg='4' xl="3" v-for="(modulo, index) in modulos" v-bind:key="index">
                                <CCard :class="(modulo.habilitado)?'cardHabil':'cardDeshab'">
                                    <CCardHeader>
                                        <div class="card-header-actions">
                                                
                                                <span v-show="!editarModulos" v-tippy="getBaseTippy(`Modulo ${modulo.asignadoCliente?'Asignado':'No Asignado'}`)">
                                                    <CIcon style="color:green" name="cil-check-circle" v-show="modulo.asignadoCliente"/>
                                                    <CIcon style="color:red" name="cil-x-circle" v-show="!modulo.asignadoCliente" />
                                                </span>
                                                <!--<span v-show="!editarModulos" v-tippy="getBaseTippy(`Modulo ${modulo.habilitado?'Habilitado':'No Habilitado'}`)">
                                                    <CIcon style="color:green" name="cil-check-circle" v-show="modulo.habilitado"/>
                                                    <CIcon style="color:red" name="cil-x-circle" v-show="!modulo.habilitado" />
                                                </span>-->
                                                <div>
                                                    <CSwitch
                                                        size="sm"
                                                        v-show="editarModulos"
                                                        class="align-middle mb-1" 
                                                        color="success" 
                                                        shape="pill"
                                                        variant="outline"
                                                        v-bind="{labelOn: 'A',labelOff: 'NA'}"
                                                        :checked="modulo.asignadoCliente"
                                                        @update:checked="asignarModulo(modulo)"
                                                    /> 
                                                </div>
                                                <div>
                                                    <CSwitch
                                                        size="sm"
                                                        v-show="editarModulos"
                                                        class="align-middle mb-1" 
                                                        color="success" 
                                                        shape="pill"
                                                        variant="outline"
                                                        v-bind="{labelOn: 'H',labelOff: 'NH'}"
                                                        :checked="modulo.habilitado"
                                                        @update:checked="habilitarModulo(modulo)"
                                                    /> 
                                                </div>
                                        </div>
                                        <div>
                                            <span v-tippy="getBaseTippy('Icono modulo')">
                                                <CIcon :name="modulo.iconoModulo" size="sm" class="mr-1" />
                                            </span> 
                                            <span  class="mr-1" style="width: auto;" v-tippy="getBaseTippy('Orden que se muestra el modulo')">({{ modulo.ordenModulo }})</span>
                                            <span v-tippy="getBaseTippy(`Nombre Modulo ${modulo.nombreModulo}`)" class="mr-1">{{ modulo.nombreModulo }}</span> 
                                        </div>
                                    </CCardHeader>

                                    <CCardBody>

                                        <CCard :class="(subModulo.habilitado)?'cardHabil':'cardDeshab'" class="mb-1"
                                            v-for="(subModulo, indexSubMod) in modulo.subModulos" v-bind:key="indexSubMod">
                                            <CCardHeader :class="(!editarModulos)?'infoDetalle':''">
                                                <div class="card-header-actions">
                                                    <span v-show="!editarModulos" v-tippy="getBaseTippy(`Sub Modulo ${subModulo.asignadoCliente?'Asignado':'No Asignado'}`)">
                                                        <CIcon style="color:green" name="cil-check-circle" v-show="subModulo.asignadoCliente"/>
                                                        <CIcon style="color:red" name="cil-x-circle" v-show="!subModulo.asignadoCliente" />
                                                    </span>
                                                    <!--<span v-show="!editarModulos" v-tippy="getBaseTippy(`Sub Modulo ${subModulo.habilitado?'Habilitado':'No Habilitado'}`)">
                                                        <CIcon style="color:green" name="cil-check-circle" v-show="subModulo.habilitado"/>
                                                        <CIcon style="color:red" name="cil-x-circle" v-show="!subModulo.habilitado" />
                                                    </span>-->

                                                    <div>
                                                        <CSwitch
                                                            v-tippy="getBaseTippy('Asignar Submodulo')"
                                                            size="sm"
                                                            v-show="editarModulos"
                                                            class="align-middle mb-1" 
                                                            color="success" 
                                                            shape="pill"
                                                            variant="outline"
                                                            v-bind="{labelOn: 'A',labelOff: 'NA'}"
                                                            :checked="subModulo.asignadoCliente"
                                                            @update:checked="asignarSubModulo(subModulo, modulo)"
                                                        /> 
                                                    </div>
                                                    <div>
                                                        <CSwitch
                                                            v-tippy="getBaseTippy('Habilitar Submodulo')"
                                                            size="sm"
                                                            v-show="editarModulos"
                                                            class="align-middle mb-1" 
                                                            color="success" 
                                                            shape="pill"
                                                            variant="outline"
                                                            v-bind="{labelOn: 'H',labelOff: 'NH'}"
                                                            :checked="subModulo.habilitado"
                                                            @update:checked="habilitarSubModulo(subModulo, modulo)"
                                                        /> 
                                                    </div>
                                                </div>
                                                <span v-tippy="getBaseTippy('Icono SubModulo')"><CIcon :name="subModulo.iconoSubmodulo" size="sm" class="mr-1" /></span>
                                                <span v-tippy="getBaseTippy('Orden que se muestra el SubModulo')">({{ subModulo.ordenSubmodulo }})</span>
                                                <span v-tippy="getBaseTippy(`Nombre SubModulo ${subModulo.nombreSubmodulo}`)" class="mr-1">{{ subModulo.nombreSubmodulo }}</span> 
                                            </CCardHeader>
                                        </CCard>
                                    </CCardBody>
                                </CCard>

                            </CCol>
                        </CRow>
                        
                    </CCardBody>
                </CCollapse>
            </CCard>

            <CCard>
                <CCardHeader 
                    @click="desplegarPropiedades" 
                    class="btn text-left"> 
                    <strong>Propiedades Cliente</strong>
                </CCardHeader>
                <CCollapse :show="verPropClientes">
                    <CCardBody class="m-1">
                        <CargandoInfo :mostrarCarga="isLoadinPropiedaedes" :mensajeInfo="'Obteniendo propiedades...'" />
                        <CRow style="padding: 10px;" v-show="!isLoadinPropiedaedes">
                            <CCol col="12">
                                <CCard v-for="(propiedad, index) in cliente.propiedadesCliente" v-bind:key="index" class="mb-1">
                                    <CCardHeader>
                                        <CRow>
                                            <CCol sm="4" md="4" lg="4">
                                                <span>{{ propiedad.nombreVisible }}</span>
                                            </CCol>
                                           <CCol sm="6" md="6" lg="6">
                                                <span v-if="propiedad.nombrePropiedad == 'tablas_REMU'" :disabled="propiedad.modificandoPropiedad">
                                                    
                                                    <CRow>
                                                         <CCol sm="7" md="6" lg="6" v-for="tabla in cliente.tablasBase.tablasBaseRemu" :key="tabla.nombreTabla">
                                                            <CIcon style="color:green" name="cil-check-circle" v-show="!propiedad.editarPropiedad" v-if="tabla.agregada"/>
                                                            <CIcon style="color:red" name="cil-x-circle" v-show="!propiedad.editarPropiedad" v-else />
                                                            <CSwitch
                                                                size="sm"
                                                                v-show="propiedad.editarPropiedad"
                                                                width="150px"
                                                                class="mx-1 align-middle mb-2" 
                                                                color="success" 
                                                                shape="pill"
                                                                variant="outline"
                                                                v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                                                :checked="tabla.agregada"
                                                                @update:checked="tabla.agregada = !tabla.agregada"
                                                            /> <span style="font-size: 11px;">{{tabla.nombreTabla}}</span>
                                                        </CCol>
                                                    </CRow>
                                                </span>
                                                <span v-else-if="propiedad.nombrePropiedad == 'tablas_CONTA'" :disabled="propiedad.modificandoPropiedad">
                                                    <CRow>
                                                        <CCol sm="7" md="6" lg="6" v-for="tabla in cliente.tablasBase.tablasBaseConta" :key="tabla.nombreTabla">
                                                            <CIcon style="color:green" name="cil-check-circle" v-show="!propiedad.editarPropiedad" v-if="tabla.agregada"/>
                                                            <CIcon style="color:red" name="cil-x-circle" v-show="!propiedad.editarPropiedad" v-else />
                                                            <CSwitch
                                                                size="sm"
                                                                v-show="propiedad.editarPropiedad"
                                                                width="150px"
                                                                class="mx-1 align-middle mb-2" 
                                                                color="success" 
                                                                shape="pill"
                                                                variant="outline"
                                                                v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                                                :checked="tabla.agregada"
                                                                @update:checked="tabla.agregada = !tabla.agregada"
                                                            /> <span style="font-size: 11px;">{{tabla.nombreTabla}}</span>
                                                        </CCol>
                                                    </CRow>
                                                </span>
                                                <span v-else :disabled="propiedad.modificandoPropiedad">
                                                    <!--<span>{{ propiedad.valorPropiedad }}</span>
                                                    <span>
                                                        <CInput
                                                            v-show="propiedad.editarPropiedad"
                                                            style="margin-top:0"
                                                            v-model="cliente.propiedadSeleccionada.valorPropiedad"
                                                            type="text"
                                                        />
                                                    </span>-->
                                                    <span v-show="!propiedad.editarPropiedad">
                                                        <span v-if="propiedad.valorPropiedad != null">{{ propiedad.valorPropiedad }}</span>
                                                        <span v-else>Sin Asignar Valor</span>
                                                    </span>
                                                    <span v-show="propiedad.editarPropiedad">
                                                        <CInput
                                                            style="margin-top:0"
                                                            v-model="propiedad.valorPropiedad"
                                                            type="text"
                                                        />
                                                    </span>
                                                </span>
                                            </CCol>
                                            <CCol sm="2" md="2" lg="2">
                                                <span v-show="!propiedad.editarPropiedad">
                                                    <CButtonGroup size="sm" v-show="!propiedad.editarPropiedad && !propiedad.eliminarPropiedad">
                                                        <CButton color="warning" size="sm"
                                                            v-tippy="getBaseTippy('Editar Propiedad')"
                                                            @click="propiedad.editarPropiedad=true;editarPropiedadCliente(propiedad)">
                                                            <CIcon name="cil-pencil"/>
                                                        </CButton>
                                                        <!--
                                                            <CButton color="danger"
                                                            v-tippy="getBaseTippy('Eliminar Propiedad')"
                                                            @click="propiedad.eliminarPropiedad = true"
                                                            size="sm" ><CIcon name="cil-x-circle"/>
                                                        </CButton>-->
                                                        
                                                    </CButtonGroup>
                                                </span>
                                                
                                                <span v-show="propiedad.editarPropiedad">
                                                    <!--:disabled="(propiedad.valorPropiedad != null)?propiedad.valorPropiedad.length==0:true || propiedad.nombrePropiedad.length==0"
                                                            -->
                                                    <CButtonGroup class="mx-1" >
                                                        <CButton v-show="propiedad.modificandoPropiedad" color="warning" size="sm">
                                                            <CIcon class="imgr" name="cil-loop-circular"/>
                                                        </CButton>
                                                        <CButton v-show="!propiedad.modificandoPropiedad" color="success" size="sm"
                                                            v-tippy="getBaseTippy('Guardar')"
                                                            @click="modificarPropiedad(propiedad)">
                                                            <CIcon name="cil-check-circle"/>
                                                        </CButton>
                                                        <CButton v-show="!propiedad.modificandoPropiedad" color="danger" size="sm"
                                                            v-tippy="getBaseTippy('Cancelar Cambios')"
                                                            @click="propiedad.editarPropiedad=false;cancelarCambios(propiedad)">
                                                            <CIcon name="cil-x-circle"/>
                                                        </CButton>
                                                    </CButtonGroup>
                                                </span>
                                            </CCol>
                                        </CRow>
                                    </CCardHeader>
                                </CCard>
                                <!--
                                <CRow>
                                    <CCol sm="4">
                                        <multiselect class="m-0 d-inline-block mb-2"
                                            :id="cliente"
                                            v-model="cliente.propiedadSeleccionada"
                                            deselect-label="" 
                                            label="nombrePropiedad" 
                                            placeholder="Propiedad" 
                                            select-label=""
                                            selectedLabel=""
                                            :options="cliente.propiedadesCliente"
                                            :searchable="true"
                                            @select="seleccionarPropiedad"
                                        >
                                        </multiselect>
                                    </CCol>
                                    <CCol sm="3">
                                        <CRow v-if="cliente.propiedadSeleccionada != null && cliente.propiedadSeleccionada.nombrePropiedad == 'tablas_REMU'">
                                            <CCol col="12">
                                                <CRow v-for="tabla in cliente.tablasBase.tablasBaseRemu" :key="tabla.nombreTabla">
                                                    <CCol>
                                                        <CIcon style="color:green" name="cil-check-circle" v-show="!cliente.propiedadSeleccionada.editarPropiedad" v-if="tabla.agregada"/>
                                                        <CIcon style="color:red" name="cil-x-circle" v-show="!cliente.propiedadSeleccionada.editarPropiedad" v-else />
                                                        <CSwitch
                                                            v-show="cliente.propiedadSeleccionada.editarPropiedad"
                                                            width="150px"
                                                            class="mx-1 align-middle mb-2" 
                                                            color="success" 
                                                            shape="pill"
                                                            variant="outline"
                                                            v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                                            :checked="tabla.agregada"
                                                            @update:checked="tabla.agregada = !tabla.agregada"
                                                        /> {{tabla.nombreTabla}}
                                                    </CCol>
                                                </CRow>
                                            </CCol>
                                        </CRow>
                                        <CRow v-else-if="cliente.propiedadSeleccionada != null && cliente.propiedadSeleccionada.nombrePropiedad == 'tablas_CONTA'">
                                            <CCol col="12">
                                                <CRow v-for="tabla in cliente.tablasBase.tablasBaseConta" :key="tabla.nombreTabla">
                                                    <CCol>
                                                        <CIcon style="color:green" name="cil-check-circle" v-show="!cliente.propiedadSeleccionada.editarPropiedad" v-if="tabla.agregada"/>
                                                        <CIcon style="color:red" name="cil-x-circle" v-show="!cliente.propiedadSeleccionada.editarPropiedad" v-else />
                                                        <CSwitch
                                                            v-show="cliente.propiedadSeleccionada.editarPropiedad"
                                                            width="150px"
                                                            class="mx-1 align-middle mb-2" 
                                                            color="success" 
                                                            shape="pill"
                                                            variant="outline"
                                                            v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                                            :checked="tabla.agregada"
                                                            @update:checked="tabla.agregada = !tabla.agregada"
                                                        /> {{tabla.nombreTabla}}
                                                    </CCol>

                                                </CRow>
                                            </CCol>
                                        </CRow>
                                        <CRow v-show="cliente.propiedadSeleccionada != null" v-else>
                                            <CCol col="12" v-show="cliente.propiedadSeleccionada != null && !cliente.propiedadSeleccionada.editarPropiedad">
                                                <CInput
                                                    v-if="cliente.propiedadSeleccionada != null"
                                                    style="margin-top:0"
                                                    v-model="cliente.propiedadSeleccionada.valorPropiedad"
                                                    plaintext
                                                />
                                            </CCol>
                                            <CCol col="12" v-show="cliente.propiedadSeleccionada != null && cliente.propiedadSeleccionada.editarPropiedad">
                                                <CInput
                                                    v-if="cliente.propiedadSeleccionada != null"
                                                    style="margin-top:0"
                                                    v-model="cliente.propiedadSeleccionada.valorPropiedad"
                                                    type="text"
                                                />
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                    <CCol col="2">
                                        
                                        <CButtonGroup size="sm" v-show="cliente.propiedadSeleccionada != null && cliente.propiedadSeleccionada.eliminarPropiedad">
                                            <CButton color="warning" size="sm"
                                                v-c-tooltip.hover="{content:'Está Seguro?', placement:'left'}"
                                                @click="eliminarPropiedad(cliente)">
                                                <CIcon name="cil-check-circle"/>
                                            </CButton>
                                            <CButton color="danger" 
                                            v-c-tooltip.hover="{content:'No!', placement:'right'}"
                                            @click="cliente.propiedadSeleccionada.eliminarPropiedad = false"
                                            size="sm" ><CIcon name="cil-x-circle"/>
                                            </CButton>
                                            
                                        </CButtonGroup>
                                        
                                        <CButtonGroup size="sm" v-show="cliente.propiedadSeleccionada != null && !cliente.propiedadSeleccionada.editarPropiedad && !cliente.propiedadSeleccionada.eliminarPropiedad">
                                            <CButton color="warning" size="sm"
                                                v-c-tooltip.hover="{content:'Editar Propiedad', placement:'left'}"
                                                @click="cliente.propiedadSeleccionada.editarPropiedad=true">
                                                <CIcon name="cil-pencil"/>
                                            </CButton>
                                            <CButton color="danger" 
                                            v-c-tooltip.hover="{content:'Eliminar Propiedad', placement:'down'}"
                                            @click="cliente.propiedadSeleccionada.eliminarPropiedad = true"
                                            size="sm" ><CIcon name="cil-x-circle"/>
                                            </CButton>
                                            
                                        </CButtonGroup>
                                        <CButtonGroup class="mx-1" v-show="cliente.propiedadSeleccionada != null && cliente.propiedadSeleccionada.editarPropiedad">
                                            <CButton color="success" size="sm"
                                                v-if="cliente.propiedadSeleccionada != null"
                                                :disabled="cliente.propiedadSeleccionada == null && cliente.propiedadSeleccionada.valorPropiedad.length==0 || cliente.propiedadSeleccionada.nombrePropiedad.length==0"
                                                v-c-tooltip.hover="{content:'Guardar', placement:'left'}"
                                                @click="modificarPropiedad(cliente)">
                                                <CIcon name="cil-check-circle"/>
                                            </CButton>
                                            <CButton color="danger" size="sm"
                                                v-if="cliente.propiedadSeleccionada != null"
                                                v-c-tooltip.hover="{content:'Cancelar Cambios', placement:'right'}"
                                                @click="cliente.propiedadSeleccionada.editarPropiedad=false">
                                                <CIcon name="cil-x-circle"/>
                                            </CButton>
                                        </CButtonGroup>
                                        
                                    </CCol>
                                </CRow>
                                <CRow v-show="cliente.agregarNuevaPropiedad">
                                    <CCol col="3">
                                        <CInput
                                            label="Nombre Propiedad"
                                            style="margin-top:10px"
                                            v-model="cliente.nuevaPropiedad.nombrePropiedad"
                                            type="text"
                                        />
                                    </CCol>
                                    <CCol col="7">
                                        <CInput
                                            label="Valor Propiedad"
                                            style="margin-top:10px"
                                            v-model="cliente.nuevaPropiedad.valorPropiedad"
                                            type="text"
                                        />
                                    </CCol>
                                    <CCol col="2">
                                        <CButtonGroup class="mx-1" :style="(cliente.agregarNuevaPropiedad)?'margin-top: 35px':''">
                                            <CButton color="success" size="sm"
                                                :disabled="cliente.nuevaPropiedad.valorPropiedad.length==0 || cliente.nuevaPropiedad.nombrePropiedad.length==0"
                                                v-c-tooltip.hover="{content:'Guardar', placement:'left'}"
                                                @click="guardarNuevaPropiedad(cliente)">
                                                <CIcon name="cil-check-circle"/>
                                            </CButton>
                                            <CButton color="danger" size="sm"
                                                v-c-tooltip.hover="{content:'Cancelar Cambios', placement:'right'}"
                                                @click="quitarPropiedadNueva(cliente)">
                                                <CIcon name="cil-x-circle"/>
                                            </CButton>
                                        </CButtonGroup>
                                    </CCol>
                                </CRow>
                                <CButton type="submit" class="mt-3 mb-2 btn-class"  
                                    @click="agregarNuevaPropiedad(cliente)">
                                    <CIcon :content="$options.freeSet.cilPlus" /> Nueva propiedad
                                </CButton>
                            -->
                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCollapse>
            </CCard>
        </CCardBody>
        <CCardFooter>
            
        </CCardFooter>
    </CCard>
    </template>
    
    <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
    
    <script>
        
        import cons from '@/const'
        import Multiselect from 'vue-multiselect'
        import axios from "axios"
        import { freeSet } from '@coreui/icons'
        import { CCardHeader, CIcon } from '@coreui/vue';
    
        
        export default {
            name: 'CrearUsuario',
            freeSet,
            props: {
                cliente: Object
            },
            components: {
                Multiselect
            },
            data () {
                return {
                    //usuLogged = JSON.parse(this.$cookie.get('userLogginToken'))
                    baseUrl: cons.protocolo+"://" + cons.ipServer + cons.puerto,
                    tokenLogin: JSON.parse(this.$cookie.get("userLogginTokenAdmin")).tokenUsuario,
    
                    regMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                    
                    
                    isLoadinPropiedaedes: false,
                    verOpcionesClientes: false,
                    verPropClientes: false,

                    editarModulos: false,
                    
                    modulos: [],
                    modulosRespaldo: [],
                    modificandoConfiguracion: false,
                }
            },
            created: function(){},
            beforeMount() {
                
    
            },
            methods: {
                desplegarOpciones: function(){
                    this.verOpcionesClientes = !this.verOpcionesClientes
                    if(this.verOpcionesClientes){
                        this.getModulosCliente()
                    }

                },
                desplegarPropiedades: function(){
                    this.verPropClientes = !this.verPropClientes
                    if(this.verPropClientes){
                        
                        this.isLoadinPropiedaedes = true
                        this.getTablasBase()
                    }
                },
                seleccionarPropiedad: function(propiedad, cliente){
                },

                getModulosCliente: function(){
                    let url = this.baseUrl + "/get_modulos_cliente/";

                    axios({
                        method: "POST", 
                        "url": url,
                        "data": {
                            "idCliente": this.cliente.idCliente
                        },
                        "headers": {
                            'Authorization': this.tokenLogin
                        }
                    }).then(result => {
                        this.modulos = result.data.modulos
                    }, error => {
                    })
                    .finally(() => {
                    });
                },
                editarModulosCliente: function(){
                    this.editarModulos = !this.editarModulos
                    this.modulosRespaldo = JSON.parse(JSON.stringify(this.modulos))
                    
                },
                cancelarEdicion: function(){
                    this.editarModulos = !this.editarModulos
                    this.modulos = JSON.parse(JSON.stringify(this.modulosRespaldo))
                },
                setModulosCliente: function(){
                    let url = this.baseUrl + "/set_modulos_cliente/";
                    this.modificandoConfiguracion = true

                    axios({
                        method: "POST", 
                        "url": url,
                        "data": {
                            "idCliente": this.cliente.idCliente,
                            "datosModulos": this.modulos
                        },
                        "headers": {
                            'Authorization': this.tokenLogin
                        }
                    }).then(result => {
                        this.mostrarNotificaciones2(4, "¡¡Excelente!!", result.data.mensajeGeneral, 'bottom-center')
                        this.editarModulos = false
                        this.modulosRespaldo = []
                    }, error => {
                        this.mostrarNotificaciones2(4, "Nooooo!!", error.response.data.mensajeGeneral, 'bottom-center')
                    })
                    .finally(() => {
                        this.modificandoConfiguracion = false
                    });
                },
                asignarModulo: function(modulo){
                    modulo.asignadoCliente = !modulo.asignadoCliente
                    
                    if (!modulo.asignadoCliente) {
                        modulo.habilitado = false
                        modulo.subModulos.forEach(submod => {
                            submod.asignadoCliente = false
                            submod.habilitado = false
                        });
                    }

                },
                asignarSubModulo: function(subModulo, modulo){
                    subModulo.asignadoCliente = !subModulo.asignadoCliente
                    if(subModulo.asignadoCliente){
                        modulo.asignadoCliente = true
                    }
                    else {
                        subModulo.habilitado = false
                        let hayHabilitados = modulo.subModulos.some(submod => submod.asignadoCliente);
        
                        modulo.asignadoCliente = hayHabilitados;
                        if(!hayHabilitados){
                            modulo.habilitado = false 
                        }

                    }
                },
                habilitarModulo: function(modulo){
                    modulo.habilitado = !modulo.habilitado
                    
                    if (modulo.habilitado) {
                        modulo.asignadoCliente = true                        
                    } else{
                        modulo.subModulos.forEach(submod => {
                            submod.habilitado = false
                        });
                    }
                },
                habilitarSubModulo: function(subModulo, modulo){
                    subModulo.habilitado = !subModulo.habilitado
                    
                    if(subModulo.habilitado){
                        modulo.habilitado = true
                        modulo.asignadoCliente = true
                        subModulo.asignadoCliente = true
                    }
                    else {
                        let hayHabilitados = modulo.subModulos.some(submod => submod.habilitado);
        
                        modulo.habilitado = hayHabilitados;
                    }

                },
                getConfigCliente: function(){
                    var url = this.baseUrl + "/get_config_cliente_vapp";

                    axios({
                        method: "POST", 
                        "url": url,
                        "data": {
                            "info": {
                                "idCliente": this.cliente.idCliente
                            }
                        },
                        "headers": {
                            'Authorization': this.tokenLogin
                        }
                    }).then(result => {

                        this.cliente.propiedadesCliente = result.data
                        this.comprobarTablas()

                        
                    }, error => {
                        this.mostrarNotificaciones2(4, "Nooooo!!", error.response.data, 'bottom-center')
                    })
                    .finally(() => {
                        this.isLoadinPropiedaedes = false
                    });
                },
                comprobarTablas: function(){
                    this.cliente.propiedadesCliente.forEach(propCli => {
                        //propCli['focus'] = false;
                        

                        let tablasPropiedad = null
                        if(propCli.nombrePropiedad == 'tablas_REMU'){
                            this.cliente.tablasBase.tablasBaseRemu.forEach(tabla => {
                                if(propCli.valorPropiedad != null){
                                    tablasPropiedad = propCli.valorPropiedad.split(',')
                                    tabla.agregada = tablasPropiedad.includes(tabla.nombreTabla)
                                }
                            })
                        } else if(propCli.nombrePropiedad == 'tablas_CONTA'){
                            this.cliente.tablasBase.tablasBaseConta.forEach(tabla => {
                                if(propCli.valorPropiedad != null){
                                    tablasPropiedad = propCli.valorPropiedad.split(',')
                                    tabla.agregada = tablasPropiedad.includes(tabla.nombreTabla)
                                }
                            })
                        }
                    })
                },
                getTablasBase: function(){
                    /*cliente.tablasBase = {
                        tablasBaseRemu: [{'nombreTabla':'TrabPersonal','agregada':false},{'nombreTabla':'Contratos','agregada':false},{'nombreTabla':'LockPeriodo','agregada':false}],
                        tablasBaseConta: [{'nombreTabla':'PCTA2021','agregada':false},{'nombreTabla':'PCTA2020','agregada':false},{'nombreTabla':'CLASER','agregada':false}]
                    
                    }*/
                    var url = this.baseUrl + "/get_config_tablas_general";

                    axios({
                        method: "POST", 
                        "url": url,
                        "headers": {
                            'Authorization': this.tokenLogin
                        }
                    }).then(result => {
                        //this.tablasBase = result.data
                        this.cliente.tablasBase = result.data
                        this.getConfigCliente()

                    }, error => {
                        this.mostrarNotificaciones2(4, "Nooooo!!", error.response.data, 'bottom-center')
                    })
                    .finally(() => {
                    });
                },
                editarPropiedadCliente: function(propiedad){
                    if(['tablas_CONTA','tablas_REMU'].includes(propiedad.nombrePropiedad)){
                        if(propiedad.nombrePropiedad == 'tablas_CONTA'){
                            propiedad.respaldosTablas = JSON.parse(JSON.stringify(this.cliente.tablasBase.tablasBaseConta))
                        }
                        else if(propiedad.nombrePropiedad == 'tablas_REMU'){
                            propiedad.respaldosTablas = JSON.parse(JSON.stringify(this.cliente.tablasBase.tablasBaseRemu))
                        }
                    }
                    else{
                        propiedad.repaldoValor = JSON.parse(JSON.stringify(propiedad.valorPropiedad))
                    }
                },
                cancelarCambios: function(propiedad){
                    if(['tablas_CONTA','tablas_REMU'].includes(propiedad.nombrePropiedad)){
                        if(propiedad.nombrePropiedad == 'tablas_CONTA'){
                            this.cliente.tablasBase.tablasBaseConta = JSON.parse(JSON.stringify(propiedad.respaldosTablas))
                        } else if(propiedad.nombrePropiedad == 'tablas_REMU'){
                            this.cliente.tablasBase.tablasBaseRemu = JSON.parse(JSON.stringify(propiedad.respaldosTablas))
                        }
                    } else{
                        propiedad.valorPropiedad = JSON.parse(JSON.stringify(propiedad.repaldoValor))
                    }

                },
                modificarPropiedad: function(propiedad){
                    propiedad.modificandoPropiedad = true
                    
                    if(['tablas_CONTA','tablas_REMU'].includes(propiedad.nombrePropiedad)){
                        let tablas = []
                        if(propiedad.nombrePropiedad == 'tablas_CONTA'){
                            this.cliente.tablasBase.tablasBaseConta.forEach(tabla => {
                                if(tabla.agregada)
                                    tablas.push(tabla.nombreTabla)
                            });
                        } 
                        else if(propiedad.nombrePropiedad == 'tablas_REMU'){
                            this.cliente.tablasBase.tablasBaseRemu.forEach(tabla => {
                                if(tabla.agregada)
                                    tablas.push(tabla.nombreTabla)
                            });
                        }

                        propiedad.valorPropiedad = tablas.join(',')

                    }
                    
                    let url = this.baseUrl + "/modificar_propiedad_cliente";
                    axios({
                        method: "POST", 
                        "url": url,
                        "data": {
                            "info": {
                                "idCliente": this.cliente.idCliente,
                                "propiedad": propiedad
                            }
                        },
                        "headers": {
                            'Authorization': this.tokenLogin
                        }
                    }).then(result => {
                        this.getConfigCliente()

                        propiedad.editarPropiedad = false
                        this.mostrarNotificaciones2(4, `${propiedad.nombreVisible}`, result.data, 'bottom-center')
                        
                    }, error => {
                        this.mostrarNotificaciones2(4, `Nooooo!!, ${propiedad.nombreVisible}`, error.response.data, 'bottom-center')
                    })
                    .finally(() => {
                        propiedad.modificandoPropiedad = false
                    });
                },
            },
            
        }
    </script>

    <style>


        .cardHabil{
            border-color: green;
        }
        .cardDeshab{
            border-color: red;
        }
    </style>